import React from "react";
import { bem } from "../../helpers";
import PropTypes from "prop-types";
// import "./Input.scss"
import BaseField from "../Field/Base";

export class Input extends BaseField {
  inputType = this.props?.type || "text";

  onFileChange = (e) => {
    this.props.onChange({ [this.props.id]: e.target.files[0] });
  };

  renderInput = () => {
    const { id, placeholder, disabled, inputProps, type } = this.props;

    if (type === "file") {
      return (
        <input
          id={id}
          name={this.name()}
          type={this.inputType}
          className={bem("field", "input")}
          placeholder={placeholder}
          disabled={disabled}
          {...inputProps}
          onChange={this.onFileChange}
        />
      );
    } else {
      return (
        <input
          id={id}
          name={this.name()}
          type={this.inputType}
          value={this.value()}
          className={bem("field", "input")}
          placeholder={placeholder}
          disabled={disabled}
          {...inputProps}
          onChange={this.onChange}
        />
      );
    }
  };
}

export default Input;
